<div
  class="panel-heading"
  [ngClass]="[isCollapsed ? 'active' : '']"
  [attr.data-testing-id]="dataTestingId"
  role="tab"
  (click)="toggleCollapse()"
  (keydown.enter)="toggleCollapse()"
  tabindex="0"
>
  <a class="accordion-toggle" [attr.aria-expanded]="isCollapsed">
    {{ heading }}
    <fa-icon *ngIf="!isCollapsed; else collapsed" class="float-right" [icon]="['fas', 'plus']"></fa-icon>
    <ng-template #collapsed> <fa-icon class="float-right" [icon]="['fas', 'minus']"></fa-icon> </ng-template>
  </a>
</div>
<div
  class="panel-collapse collapse"
  [ngClass]="[isCollapsed ? 'active' : '']"
  role="tabpanel"
  [ngbCollapse]="!isCollapsed"
>
  <div class="panel-body"><ng-content></ng-content></div>
</div>
